import RotateLoader from "react-spinners/RotateLoader";
import React from "react";
import { useAuth } from "./AuthProvider";

export default function LoadingIcon({ cl }) {
  const { loading } = useAuth();
  return loading ? (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <RotateLoader size={45} margin={35} color={cl || "#3f51b5"} />
    </div>
  ) : (
    <div></div>
  );
}
